export default __webpack_public_path__ + "static/media/8.3.8804c7cd.mp4";